import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import selectedIcon from '../MailLogin/selected.png';
import unselectedIcon from '../MailLogin/unselected.png';
import loadingGif from './loading.gif';
import { MOBILE_LOGIN_CONF } from '../../../config';
import { trackEventLog } from '../../../core/utils';


class MobileLogin extends React.Component {
  static propTypes = {
    logIn: PropTypes.func.isRequired,
    backurl: PropTypes.string.isRequired,
    virtualMobilefetch: PropTypes.func.isRequired,
    // isUseBind: PropTypes.bool, // 用于用户绑定
    needBind: PropTypes.bool,
    isUpdateBind: PropTypes.bool,
    bindMobile: PropTypes.func,
    // forceBindMobile: PropTypes.func,
    updateBindMobile: PropTypes.func,
    getPhoneNumber: PropTypes.func,
  }

  static contextTypes = {
    query: PropTypes.object,
  }

  static defaultProps = {
    needBind: false,
    isUpdateBind: false,
    bindMobile: () => {},
    forceBindMobile: () => {},
    updateBindMobile: () => {},
    getPhoneNumber: () => {},
    logininfo: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      remember: true,
      loadingShow: true,
    }
    this.handleVirtualMobile = this.handleVirtualMobile.bind(this)
    this.handleMobileLogin = this.handleMobileLogin.bind(this)
  }

  componentDidMount() {
    const {
      needBind,
    } = this.props
    if (needBind) {
      MOBILE_LOGIN_CONF.cssFiles = 'ke/login/20200701/web-without-password.css'
      MOBILE_LOGIN_CONF.uniteLogin.loginTxt = '确 定'
    }
    // 手机帐号登录或注册,初始化完成回调
    MOBILE_LOGIN_CONF.mbInitSuccess = () => {
      this.mobileInitSucc()
    }
    // 登录成功后回调
    MOBILE_LOGIN_CONF.logincb = (phoneNumber) => {
      try {
        window.urs1 && window.urs1.loginDolockMb() // eslint-disable-line
        this.handleVirtualMobile(phoneNumber)
      } catch (e) {
        console.log(`There has been a problem with logincb: ${e.message}`);
      }
    }

    try {
      window.urs1 = new URS(MOBILE_LOGIN_CONF); // eslint-disable-line
    } catch (e) {
      const loadMessageError2 = () => {
        // message加载失败降级到nginx,产品可以在load事件重新初始化
        const cdnPath = 'https://dl.reg.163.com/webzj/ngx/message.js';
        const script = document.createElement('script');
        script.src = cdnPath;
        document.body.appendChild(script);
      }
      // message加载失败降级备份cdn域名,产品可以在load事件重新初始化
      const cdnPath = 'https://webzj.netstatic.net/webzj_cdn101/message4.js';
      const script = document.createElement('script');
      script.src = cdnPath;
      script.onerror = loadMessageError2
      document.body.appendChild(script);
    } finally {
      if (!window.urs1) {
        setTimeout(() => {
          window.urs1 = new URS(MOBILE_LOGIN_CONF); // eslint-disable-line
        }, 500)
      }
    }
  }

  mobileInitSucc = () => {
    this.setState({
      loadingShow: false,
    })
  }
  handleRember = () => {
    const { remember } = this.state
    this.setState({
      remember: !remember,
    });
  }

  // eslint-disable-next-line consistent-return
  handleVirtualMobile = async (phoneNumber) => {
    const { virtualMobilefetch } = this.props
    const data = await virtualMobilefetch(phoneNumber)
    if (data && data.data && data.data.result) {
      console.log(data)
      const check = confirm('您所输入的号码为虚拟号，请输入正确入网的手机号码用以登录')
      if (check) {
        window.location.reload()
      } else {
        window.location.reload()
      }
      return true
    }
    this.handleMobileLogin(phoneNumber)
  }
    // 手机号登录操作
  handleMobileLogin = async (phoneNumber) => {
    try {
      const { remember } = this.state
      const { query } = this.context
      const {
        backurl, logIn, needBind, isUpdateBind, bindMobile,
        updateBindMobile, getPhoneNumber,
      } = this.props

      // 获取当前手机号
      getPhoneNumber(phoneNumber)

      if (needBind) {
        const setCookieRes = await logIn(9) || {} // 设置绑定所需cookie
        if (setCookieRes.code !== 0) {
          alert('绑定失败：无法正常设置绑定信息')
          throw new Error(`手机号：${phoneNumber}，绑定失败：无法正常设置绑定信息`)
        }

        if (!isUpdateBind) {
          // 第三方账号绑定手机账号
          await bindMobile() // 调用绑定接口, 通过store
          return
        }
        const updateBindResult = await updateBindMobile() || {} // 调用更新绑定接口
        const { code } = updateBindResult

        trackEventLog('ChangeBindPhoneResult', {
          succ: code === 0,
          type: code,
          Pdt: query.Pdt,
        })

        if (code === 0) { // 更新成功，返回指定页
          window.location.href = backurl
          return
        }
        alert('手机号已存在，更换绑定失败！请改用该手机号直接登录。')
        throw new Error(`手机号：${phoneNumber}更换绑定失败`)
      } else {
        console.log('loginWithoutBind')
        // wap端无需检测是否需要自动登录，默认自动登录
        const loginRes = await logIn(remember ? 7 : 3) || {}

        if (loginRes.code !== 0) {
          alert('登录失败，请刷新页面重试～')
          trackEventLog('LoginFail', { type: 'Phone', msg: loginRes });
          throw new Error(`手机号：${phoneNumber}，登录服务请求失败`)
        }
        trackEventLog('LoginSuccess', { type: 'Phone' })

        window.location.href = backurl
        return
      }
    } catch (error) {
      console.error(`URS登录组件回调处理失败：${error}`)
    }
    window.urs1 && window.urs1.loginUnlockMb() // eslint-disable-line
  }

  render() {
    const { loadingShow, remember } = this.state
    const { needBind } = this.props
    return (
      <div>
        <div className={s.mobileContent}>
          <div id="mobileLogin" className={s.mobileLogin} />
          {
            loadingShow &&
            <img src={loadingGif} className={s.loading} alt="#" />
          }

          {
            !loadingShow && !needBind &&
            <div className={s.remember}>
              <img
                className={s.checkbox}
                src={remember ? selectedIcon : unselectedIcon}
                alt="勾选"
                onClick={this.handleRember}
              />
              <label htmlFor onClick={this.handleRember}>自动登录</label>
              <a
                href="https://mob.163.com"
                target="_blank"
                rel="noopener noreferrer"
                className={s.forget}
              >遇到问题?</a>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default withStyles(s)(MobileLogin);



// WEBPACK FOOTER //
// ./src/components/p_login/MobileLogin/index.js